module.exports = __webpack_public_path__ + "img/perforaciones_16-9_960.f07395b3.webp";